import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import moment from 'moment';
import 'moment-timezone';

const Heading = styled.th`
  text-align: center;
  color: #343a46;
  font-size: 13px;
  font-weight: 600;
`

const Timetable = styled.table`
  table-layout: fixed;
  margin-bottom: 24px;

  &.table > thead > tr > th {
    border-top: none;
    border-bottom: 1px solid #d8deea;
    padding: 8px 6px;
  }

  &.table > tbody > tr > th,
  &.table > tbody > tr > td {
    height: 24px;
    padding: 0;
    border-top: 1px solid #e8ecf3;
  }

  &.table > tbody > tr > td {
    border-left: 1px solid #eef1f6;
  }

  &.table > tbody > tr:last-child > td {
    border-bottom: 1px solid #e8ecf3;
  }
`

const TableBody = styled.tbody`
  line-height: 1;
`

const AvailableCell = styled.td`
  background-color: #ffffff;
`

const TimeCell = styled.th`
  border-top: none !important;
  text-align: right;
  width: 65px;
  color: #687184;
  font-size: 12px;
  font-weight: 400;
  padding-right: 8px !important;
`

const TimeText= styled.div`
    position: relative;
    top: -9px;
`

const TopLeft = styled.th`
  border-bottom: none !important;
  width: 65px;
`

const RoomBookingStart = styled.td`
  background-color:${props => props.backgroundColour};
  border: 2px solid #ffffff !important;
  border-bottom-width: 0 !important;
  border-radius: 4px 4px 0 0;
`
const RoomBooking = styled.td`
  background-color:${props => props.backgroundColour};
  border-color: #ffffff !important;
  border-style: solid !important;
  border-width: 0 2px !important;
`

const RoomBookingEnd = styled.td`
  background-color:${props => props.backgroundColour};
  border-color: #ffffff !important;
  border-style: solid !important;
  border-width: 0 2px 2px !important;
  border-radius: 0 0 4px 4px;
`

const RoomBookingSingle = styled.td`
  background-color:${props => props.backgroundColour};
  border: 2px solid #ffffff !important;
  border-radius: 4px;
`

const BookingLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 0.45);
  font-size: 11px;
  font-weight: 400;
`

class TimetableContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    events: this.props.events,
    day: this.props.day
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
        this.setState(this.props);
    }
  }

  createTableBody = () => {
    let tableBody = [];
    let startTime = moment(this.state.day).add(10,'h');
    let endTime = moment(startTime).add(30,'m');
    
    //let backgroundColour = ['#a2b8ec','#B0E57C','#FFAEAE','#FFEC94','#B4D8E7'];
    //let backgroundColour = ['#95afee','#9CCF31','#CE0000','#F7D708','#009ECE'];
    let backgroundColour = ['#4c6090','#4c6090','#4c6090','#4c6090','#4c6090'];
    //let backgroundColour = ['#4c6090','#4b7820','#a33b3b','#f0d553','#74b2ca'];

    for (let i = 0; i < 26; i++) {
        let cells = [<TimeCell key={i} scope="row"><TimeText>{startTime.format('HH.mm').toString()}</TimeText></TimeCell>];
        for (let j = 1; j <=5; j++) {
            let bookings = this.state.events.filter(e => e.room === j)[0].bookings;
            let formatted = false;
            for (let index = 0; index <= bookings.length-1; index++) {
                if (bookings[index].start.isSame(startTime) && bookings[index].end.isSame(endTime)) {
                    cells.push(<RoomBookingSingle key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ><BookingLabel>booked</BookingLabel></RoomBookingSingle>);
                    formatted = true;
                    break;
                }
                else if (bookings[index].start.isSame(startTime)) {
                    cells.push(<RoomBookingStart key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ><BookingLabel>booked</BookingLabel></RoomBookingStart>);
                    formatted = true;
                    break;
                }
                else if (bookings[index].start.isBefore(startTime) && bookings[index].end.isAfter(endTime)) {
                    cells.push(<RoomBooking key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ></RoomBooking>);
                    formatted = true;
                    break;
                }
                else if (bookings[index].end.isSame(endTime)) {
                    cells.push(<RoomBookingEnd key={"col" + i + "row"+j} backgroundColour={backgroundColour[j-1]} ></RoomBookingEnd>);
                    formatted = true;
                    break;
                };
            };
            if (formatted === false) {
                cells.push(<AvailableCell key={"col" + i + "row"+j}  ></AvailableCell>);
            }
        }

        tableBody.push(<tr key={"row"+i} >{cells}</tr>);
           
        startTime = moment(startTime.add(30, 'm'));
        endTime = moment(startTime).add(30,'m');
    }

    tableBody.push(<tr key={"row27"} >
      <TimeCell scope="row"><TimeText>{startTime.format('HH.mm').toString()}</TimeText></TimeCell>
      <AvailableCell></AvailableCell>
      <AvailableCell></AvailableCell>
      <AvailableCell></AvailableCell>
      <AvailableCell></AvailableCell>
      <AvailableCell></AvailableCell>
      </tr>);

    return tableBody
  }



  render () {
    return (
        <Timetable className="table">
          <thead>
            <tr>
              <TopLeft scope="col"></TopLeft>
              <Heading scope="col">Room 1</Heading>
              <Heading scope="col">Room 2</Heading>
              <Heading scope="col">Room 3</Heading>
              <Heading scope="col">Room 4</Heading>
              <Heading scope="col">Room 5</Heading>
            </tr>
          </thead>
          <TableBody>
          {this.createTableBody()}
          </TableBody>
        </Timetable>
    )
  }
}

export default TimetableContainer;



// WEBPACK FOOTER //
// ./src/roomTimetable/TimetableContainer.js